import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: 'd5570b53f32ea79d164a16a27f979052.png',
	fr: 'b5e67c0a6f564b18b369ee7c3fff7e5b.png',
};

export const FlowSection: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading
						as="h2"
						dangerouslySetInnerHTML={{
							__html: t(
								'flowlandingpage_title_yourpersonalizedinfinitemix_standalone-web',
								{ns: 'flow'},
							),
						}}
					/>
					<LandingParagraph>
						{t(
							'featureslandingpage_text_yourpersonalizedinfinitemix_standalone-web',
							{ns: 'features'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					h={{base: '250px', md: '100%'}}
					alt={t('metatag_text_musicbasedonyourmood_standalone-web', {
						ns: 'common',
					})}
					quality={90}
					objectFit={{base: 'cover', sm: 'contain'}}
					aspectRatio="1440/420"
					src={src}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'flow'}}
					href="/features/flow"
				>
					{t('generic_action_discoverflow_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
